// 利润
import React, { useEffect } from "react";
import * as echarts from "echarts";
import CountUp from "react-countup";
import { Statistic } from "antd";

export default function ProfitData(props) {
  const formatter = (value) => (
    <CountUp end={value} separator="," prefix="￥" suffix="元" decimals={2} />
  );
  const colorArr2 = [
    "rgba(11, 83, 128)",
    "rgba(2, 143, 224)",
    "rgba(11, 83, 128)",
  ];
  const data = [26, 14, 35, 10, 20, 26, 14, 35, 10, 20, 26, 14, 35, 10, 20];
  const xdata = [
    "2023-07-08",
    "2023-07-10",
    "2023-07-12",
    "2023-07-14",
    "2023-07-16",
    "2023-07-18",
    "2023-07-20",
    "2023-07-22",
    "2023-07-24",
    "2023-07-26",
    "2023-07-28",
    "2023-07-30",
    "2023-08-01",
    "2023-08-03",
    "2023-08-05",
  ];
  const data2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  const barWidth = 15;
  const color2 = {
    type: "linear",
    x: 0,
    x2: 0,
    y: 1,
    y2: 0,
    colorStops: [
      {
        offset: 0,
        color: "#ffffff00",
      },
      {
        offset: 0.3,
        color: "#208fdf",
      },
      {
        offset: 1,
        color: colorArr2[1],
      },
    ],
  };

  const option = {
    grid: {
      top: "22%",
      left: "7%",
      right: "7%",
      bottom: "8%",
      containLabel: true,
    },
    tooltip: {
      show: true,
      formatter: "{b}: {c}元",
      trigger: "axis",
      axisPointer: {
        type: "shadow",
        shadowStyle: {
          color: "rgba(48,95,237,0.1)",
        },
      },
      backgroundColor: "rgba(255,255,255,1)",
      padding: [5, 10],
      textStyle: {
        color: "#7588E4",
      },
      extraCssText: "box-shadow: 0 0 5px rgba(0,0,0,0.3)",
    },
    legend: {
      show: false,
      right: 20,
      orient: "horizontal",
      data: ["利润"],
      textStyle: {
        fontSize: 14,
        color: "#9ebbdf",
      },
    },
    xAxis: {
      data: xdata,
      axisLine: {
        show: true,
        lineStyle: {
          color: "#4d565e",
        },
      },
      axisLabel: {
        color: "#a0acb2",
        fontSize: 14,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: [
      {
        type: "value",
        name: "单位（元）",
        splitNumber: 4,
        max: 35,
        nameTextStyle: {
          color: "#9ebbdf",
          fontSize: 14,
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#EDEDED",
          },
        },
        axisLabel: {
          color: "#A2AEB4",
          fontSize: 14,
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "#1c2538",
            type: "dashed",
          },
        },
      },
    ],
    series: [
      {
        z: 1,
        name: "利润",
        type: "bar",
        barWidth: barWidth,
        barGap: "50%",
        data: data2,
        itemStyle: {
          normal: {
            color: color2,
            //柱形图上方标题
            label: {
              show: true,
              position: "top",
              valueAnimation: true,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
            },
          },
        },
      },
      {
        z: 2,
        name: "老龄人口数",
        type: "pictorialBar",
        data: data2.map((item) => item + 90),
        symbol: "diamond",
        //symbolOffset: ["15%", "10%"],
        symbolSize: [barWidth, 10],
        itemStyle: {
          normal: {
            color: "#ffffff00",
          },
        },
        tooltip: {
          show: false,
        },
      },
      {
        z: 3,
        name: "老龄人口数",
        type: "pictorialBar",
        symbolPosition: "end",
        data: data2,
        symbol: "diamond",
        symbolOffset: ["0", "-60%"],
        symbolSize: [barWidth, (10 * barWidth) / barWidth],
        itemStyle: {
          normal: {
            borderWidth: 2,
            color: "#60B8FF",
          },
        },
        tooltip: {
          show: false,
        },
      },
    ],
    animationDuration: 0,
    animationDurationUpdate: 3000,
    animation: true,
    animationEasing: "linear",
    animationEasingUpdate: "linear",
  };

  useEffect(() => {
    var myEchart = echarts.init(document.getElementById("profit"));
    setTimeout(function () {
      myEchart.setOption({
        series: [
          {
            type: "bar",
            data,
          },
          {
            type: "pictorialBar",
            data: data.map((item) => item + 90),
          },
          {
            type: "pictorialBar",
            data,
          },
        ],
      });
    }, 10);
    myEchart.setOption(option);
    window.addEventListener("resize", function () {
      myEchart.resize();
    });
    setInterval(() => {
      myEchart.clear();
      myEchart.setOption(option);

      setTimeout(function () {
        myEchart.setOption({
          series: [
            {
              type: "bar",
              data,
            },
            {
              type: "pictorialBar",
              data: data.map((item) => item + 90),
            },
            {
              type: "pictorialBar",
              data,
            },
          ],
        });
      }, 10);
    }, 10000);
  }, []);
  return (
    <>
      <div className="profit">
        <span className="profit-title">利润</span>
        <div className="profit-statistics">
          <div className="total item">
            <div className="inner-border">
              <span className="top drop">.</span>
              <span className="right drop">.</span>
              <span className="bottom drop">.</span>
              <span className="left drop">.</span>
              <div className="num">
                <Statistic title="总利润" value={55} formatter={formatter} />
              </div>
            </div>
          </div>
          <div className="yesterday item">
            <div className="inner-border">
              <span className="top drop">.</span>
              <span className="right drop">.</span>
              <span className="bottom drop">.</span>
              <span className="left drop">.</span>
              <div className="num">
                <Statistic
                  title="昨日利润"
                  value={117.86}
                  formatter={formatter}
                />
              </div>
            </div>
          </div>
          <div className="month item">
            <div className="inner-border">
              <span className="top drop">.</span>
              <span className="right drop">.</span>
              <span className="bottom drop">.</span>
              <span className="left drop">.</span>
              <div className="num">
                <Statistic
                  title="本月利润"
                  value={25.86}
                  formatter={formatter}
                />
              </div>
            </div>
          </div>
        </div>
        <div id="profit" className="profit-pie"></div>
      </div>
    </>
  );
}
